import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from "../_services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor(
    private authService: AuthService,
    private router: Router) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const [res, approved] = await Promise.all([
      this.authService.isConnected(),
      this.authService.isApprovedCurrentUser(),
    ]);
    if (!res) {
      if (this.router.url === '/') {
        this.router.navigate(['login']).then();
      } else {
        this.router.navigate(['login'], { queryParams: { returnUrl: state.url } }).then();
      }
    } else {
      if (!approved) {
        return this.router.createUrlTree(['/logout'], { queryParams: { returnUrl: state.url } });
      }
    }
    return res;
  }

  async canLoad(route: Route): Promise<boolean> {
    let user = await this.authService.getUser();
    if (user && user.admin) return true;
    this.router.navigateByUrl("/not-found");
    return false;
  }

}
